/**
 * 56px - is tabbar Height
 */
export const TABBAR_HEIGHT = 56;
export const COOKIE_REGION_URL = 'regionUrl';
export const COOKIE_REGION_ID = 'regionId';
export const LS_PROMOCODE_APPLIED = 'promoCodeApplied';
